import { authTokenKey } from './config';

export const getToken = () => localStorage.getItem(authTokenKey) || null;

export const setToken = (token) => localStorage.setItem(authTokenKey, token);

export const removeToken = () => localStorage.removeItem(authTokenKey);
